import React from 'react';
import Blocks from './Blocks';
import { IPageFields } from '@/types/contentful';
import classNames from 'classnames';

export function PageBlocks({ pageBlocks }: IPageFields) {
  return (
    <div className="mb-20 flex w-full flex-col gap-y-20 tablet:mb-[120px] tablet:gap-y-[120px]">
      {pageBlocks?.map(({ sys, fields }: any) => {
        const isNoteworthySocialProof =
          sys?.contentType?.sys?.id === 'noteworthySocialProof';
        const isVariationContainer =
          sys?.contentType?.sys?.id === 'variationContainer';

        return (
          <section
            key={sys?.id}
            data-cfid={sys?.id}
            data-testid="page-block"
            className={classNames({
              '-mb-20 tablet:-mb-[120px]': isVariationContainer,
              '-mt-20 tablet:-mt-[120px]': isNoteworthySocialProof
            })}
          >
            <Blocks sys={sys} fields={fields} isBodyElement />
          </section>
        );
      })}
    </div>
  );
}
